module.exports = __webpack_public_path__ + "img/alien-spaceship.94e4ca9e.svg";